import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useScheduleDayListQuery } from "src/api/scheduleAPI";
import { useAppSelector } from "src/store/actions/action";
import moment from "moment";
import cn from "classnames";
import SVG from "src/utils/SVG";
import styled from "styled-components";
interface scheduleProps {
  date: Date;
  parentFunc?: any;
}
const TodayItem = (props: scheduleProps) => {
  const [init, setInit] = useState({ apiSkip: true, reRender: true });
  const { apiSkip, reRender } = init;

  const clickDate = moment(props.date).format("YYYYMMDD");

  const scheduleDayList = useScheduleDayListQuery(clickDate, { skip: apiSkip });
  const { refetch } = useScheduleDayListQuery(clickDate);

  useEffect(() => {
    if (scheduleDayList.isSuccess) {
      props.parentFunc(scheduleDayList.data.asCount, scheduleDayList.data.noticeCount);
    }
  }, [scheduleDayList]);
  useEffect(() => {
    setInit({
      ...init,
      apiSkip: false,
      reRender: reRender ? false : true,
    });
  }, [props.date]);

  return (
    <>
      {scheduleDayList.isSuccess ? (
        <>
          {scheduleDayList.data.schedules.length > 0 ? (
            <>
              {scheduleDayList.data.schedules.map((v: any, i: number) => {
                return (
                  <li key={i}>
                    <StyledLink to={v.schedule_type === "A" ? "/as-detail/" + v.idx : "/notice-detail/" + v.idx}>
                      <p className="category">
                        {/* TODO 방문 정보 수정 해야 함 */}
                        <span className={cn("color-chip", { notice: v.schedule_type === "N" })}></span> {v.schedule_type === "A" ? "A/S 방문" : "이행 마감"}
                      </p>
                      {v.schedule_type === "A" ? (
                        <div>
                          <p className="title">{v.cate_name}</p>
                          <p className="summary">{v.contents}</p>
                          <p className="sub-info">
                            <span className="shop-type">{v.store_type_name}</span>
                            <span>
                              <span className="shop-name">
                                {v.name}
                                {v.new_yn === "Y" && <SVG name="new" width={10} height={16} viewBox="0 0 10 16" />}
                              </span>
                              <span className="date">{moment(v.insert_date).format("YYYY.MM.DD")}</span>
                            </span>
                          </p>
                        </div>
                      ) : (
                        <div>
                          <p className="type">{v.cate_name}</p>
                          <p className="title">{v.title}</p>
                          <p className="sub-info">
                            <span className="shop-name">{v.vmd_name}</span>
                            <span className="date">{moment(v.insert_date).format("YYYY.MM.DD")}</span>
                          </p>
                        </div>
                      )}
                    </StyledLink>
                  </li>
                );
              })}
            </>
          ) : (
            <>
              <li className="no-result">
                <p className="summary">일정없음</p>
              </li>
            </>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
};

const StyledLink = styled(Link)`
  .category {
    padding-bottom: 8px;
    margin-left: -15px;
    font-weight: 500;
    line-height: 20px;
    & ~ div {
      padding-top: 8px;
      border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
    }
    .color-chip {
      position: relative;
      top: 0px;
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 5px;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.color.markAs};
      &.notice {
        background-color: ${({ theme }) => theme.color.markNotice};
      }
    }
  }
  .type {
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 12px;
    line-height: 20px;
  }
  .title {
    margin-top: 4px;
    color: ${({ theme }) => theme.color.primary};
    font-size: 16px;
    font-weight: 700;
  }
  .summary {
    margin-top: 4px;
    color: ${({ theme }) => theme.color.primary};
    line-height: 20px;
    ${({ theme }) => theme.textOverflow.singleLine()};
  }
  .sub-info {
    margin-top: 4px;
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 12px;
    > span:first-child {
      position: relative;
      margin-right: 10px;
      padding-right: 10px;
      &::after {
        position: absolute;
        right: 0;
        top: 50%;
        content: "";
        display: block;
        width: 2px;
        height: 10px;
        margin-top: -5px;
        background-color: ${({ theme }) => theme.color.lineSecondary};
      }
    }
    .shop-name {
      margin-right: 15px;
      > svg {
        position: relative;
        top: -1px;
        margin-left: 2px;
      }
    }
    .date {
      color: ${({ theme }) => theme.color.tertiary};
      font-family: "Poppins";
      font-weight: 400;
    }
  }
`;

export default TodayItem;
